
function pageHeight() {
	var body = document.body,
	    html = document.documentElement;

	var height = Math.max( body.scrollHeight, body.offsetHeight, 
	                       html.clientHeight, html.scrollHeight, html.offsetHeight );

	return height;
}

module.exports = pageHeight;


/** WEBPACK FOOTER **
 ** ./src/js/helpers/pageHeight.js
 **/